import { defineMessages } from 'react-intl';

export default defineMessages({
    fnolSelectAddress: {
        id: 'tdic.fnol.common.directives.loss-location.Select Address',
        defaultMessage: 'Select Address'
    },
    fnolChooseAddress: {
        id: 'tdic.fnol.common.directives.loss-location.-- Choose Address --',
        defaultMessage: '-- Choose Address --'
    },
});
